<div class="columns is-centered">
  <div class="column is-5-desktop is-10-touch is-offset-1-touch">
    <div class="text-brackets has-text-link">
      <div class="content"><ng-content></ng-content></div>
      <div class="bracket bracket-left"></div>
      <div class="bracket bracket-right"></div>
    </div>
  </div>
</div>
